import { FC } from 'react';

import { ObservationContainer } from './styles';

interface ITicketObservationModalProps {
  readonly observation: string;
  readonly fromClick?: boolean;
}
export const TicketObservationModal: FC<ITicketObservationModalProps> = ({
  observation,
  fromClick = false,
}) => {
  return (
    <ObservationContainer>
      <span>{observation}</span>
      {!fromClick && <small>Aperte novamente para fechar</small>}
    </ObservationContainer>
  );
};
